import "react-datepicker/dist/react-datepicker.css";

import { zodResolver } from "@hookform/resolvers/zod";
import { t } from "@lingui/macro";
import { awardSchema, defaultAward } from "@reactive-resume/schema";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  RichInput,
} from "@reactive-resume/ui";
// import moment from "moment";
import DatePicker from "react-datepicker";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { AiActions } from "@/client/components/ai-actions";

import { SectionDialog } from "../sections/shared/section-dialog";
import { URLInput } from "../sections/shared/url-input";
import { useState } from "react";
const formSchema = awardSchema;

type FormValues = z.infer<typeof formSchema>;

export const AwardsDialog = () => {
  const form = useForm<FormValues>({
    defaultValues: defaultAward,
    resolver: zodResolver(formSchema),
  });
  const [selectedDate, setSelectedDate] = useState(null);
  const handleDateChange = (date: any) => {
    date.setDate(date.getDate() + 1);
    setSelectedDate(date);
    let data = date.toISOString().split("T")[0].split("-").reverse().join("-");
    // console.log("hcl",data,date.toISOString().split('T')[0])
    form.setValue("date", data);
  };

  return (
    <SectionDialog<FormValues> id="awards" form={form} defaultValues={defaultAward}>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <FormField
          name="title"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t({ message: "Title", context: "Name of the Award" })}</FormLabel>
              <FormControl>
                <Input {...field} max={50} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          name="awarder"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t`Awarder`}</FormLabel>
              <FormControl>
                <Input {...field} max={50} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        {/* <FormField
          name="date"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel style={{ marginRight: '5px' }}>{t`Date`}</FormLabel>
              <FormControl>
              <DatePicker
              {...field}
              placeholderText = {"dd-MM-yyyy"}
              dateFormat={"dd/MM/yyyy"}
              yearDropdownItemNumber={80}
              onChange={handleDateChange}
              className="custom-datepicker"
              
            />
               
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        /> */}

        <FormField
          name="date"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel style={{ marginRight: "5px" }}>From Date</FormLabel>
              <FormControl style={{ display: "hidden" }}>
                <DatePicker
                  {...field}
                  selectsStart
                  // selected={field.value}
                  placeholderText={"dd-mm-yyyy"}
                  dateFormat={"dd-MM-yyyy"}
                  showYearDropdown
                  scrollableYearDropdown
                  yearDropdownItemNumber={80}
                  //   onChange={(fromDate: any) => {
                  //     field.onChange(field.value.toISOString().split('T')[0].split('-').reverse().join('/'))

                  // }}
                  onChange={handleDateChange}
                  className="custom-datepicker"
                />
                {/* <DatePicker
                  type="text"
                  name="sdate"
                  value={field.value}
                  dateFormat="dd-MM-yyyy"
                  selected={field.value}
                  onChange={(value)=>{setValue(')}}
                /> */}
                {/* <Input {...field} type="date" placeholder="dd-mm-yyyy" value="" min="1997-01-01" max="2030-12-31"/> */}
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          name="summary"
          control={form.control}
          render={({ field }) => (
            <FormItem className="sm:col-span-2">
              <FormLabel>{t`Summary`}</FormLabel>
              <FormControl>
                <RichInput
                  {...field}
                  content={field.value}
                  onChange={(value) => field.onChange(value)}
                  max={100}
                  footer={(editor) => (
                    <AiActions value={editor.getText()} onChange={editor.commands.setContent} />
                  )}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </SectionDialog>
  );
};
